export const STATUSES = [
  {
    id: 0,
    name: "Enregistré",
    details: "Patient enregistré en salle d'attente",
    next: 1,
    by: "automatique",
  },
  {
    id: 1,
    name: "Attente infirmière",
    details: "Patient enregistré et envoyé en salle",
    next: 2,
    by: "secretaire",
  },
  {
    id: 2,
    name: "Infirmière",
    details: "Patient avec l'infirmière (1ère interaction)",
    next: 3,
    by: "infirmiere",
  },
  {
    id: 3,
    name: "Attente médecin",
    details: "Patient a terminé avec l'infirmière, en attente du médecin",
    next: 4,
    by: "infirmiere",
  },
  {
    id: 4,
    name: "Médecin",
    details: "Patient avec le médecin",
    next: [5, 7],
    by: "medecin",
  },
  {
    id: 5,
    name: "Attente infirmière (2)",
    details: "Patient a terminé avec le médecin, en attente de l'infirmière",
    next: 6,
    by: "medecin",
  },
  {
    id: 6,
    name: "Infirmière (2)",
    details: "Patient avec l'infirmière (2e interaction)",
    next: 7,
    by: "infirmiere",
  },
  {
    id: 7,
    name: "En sortie",
    details: "Patient renvoyé à l'accueil",
    next: 8,
    by: "medecin",
  },
  {
    id: 8,
    name: "Finalisé",
    details: "Parcours terminé et validé",
    next: null,
    by: "secretaire",
  },
  {
    id: 999,
    name: "Archivé",
    details: "Fin de parcours (archivage automatique)",
    next: null,
    by: "automatique",
  },
];

export const STATUS_MAP = new Map(STATUSES.map((s) => [s.id, s]));

export const getStep = (p) =>
  p?.currentStep ?? p?.currentstep ?? p?.current_step ?? null;

export const statusLabel = (step) =>
  STATUS_MAP.get(step ?? -1)?.name ?? `Étape ${step}`;

export const isArchived = (p) => getStep(p) === 999;

export const isOut = (p) => {
  const s = Number(getStep(p));
  return Number.isFinite(s) && s >= 7; // 7,8,9,999...
};

export const isActive = (p) => {
  const s = Number(getStep(p));
  return Number.isFinite(s) && s >= 1 && s <= 6; // 1..6 uniquement
};
